(function () {
    'use strict';
    var controllerId = 'schedaCompetenzeProfiloDetail';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'common', 'schedaCompetenzeDetail', schedaCompetenzeDetailFn]);

    function schedaCompetenzeDetailFn($scope, $uibModalInstance, datacontext, common, schedaCompetenzeDetail) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.schedaCompetenzeDetail = schedaCompetenzeDetail;
        $scope.Titolo = 'Personalizza';
        $scope.Titolo1 = 'CompetenzaBase';

        $scope.abilita = schedaCompetenzeDetail.Abilita;
        $scope.conoscenze = schedaCompetenzeDetail.Conoscenze;

        $scope.disabled = false;

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = {};
                result = ($scope.schedaCompetenzeDetail);

                $uibModalInstance.close($scope.schedaCompetenzeDetail);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };  
    }

})();